export default __webpack_public_path__ + "static/media/SpaceGrotesk-Regular.094a738d.woff";